import { PlusOutlined } from "@ant-design/icons";
import { Divider, Select, Space, Button } from "antd";
import React from "react";
import "../../styles/custom-dropdown.css";

function SelectWithAdd({
  placeholder,
  options,
  labelKey,
  valueKey,
  onSelect,
  addItem,
  buttonDisabled = true,
  disabled = false,
  style = {},
  value,
}) {
  return (
    <div style={{ width: "100%" }}>
      <Select
        showSearch
        size="middle"
        style={{ width: "100%", ...style }}
        className="custom-select"
        placeholder={placeholder}
        optionFilterProp="value"
        filterOption={(input, option) =>
          option?.value.toLowerCase().includes(input.toLowerCase())
        }
        dropdownRender={(menu) => (
          <>
            {menu}
            <Divider style={{ margin: "8px 0" }} />
            <Space style={{ padding: "0 8px 4px" }}>
              <Button
                type="text"
                disabled={buttonDisabled}
                icon={<PlusOutlined />}
                onClick={addItem}
              >
                Add Item
              </Button>
            </Space>
          </>
        )}
        onSelect={onSelect}
        options={options.map((item) => ({
          label: item[labelKey],
          value: item[valueKey],
        }))}
        disabled={disabled}
        value={value || undefined}
      />
    </div>
  );
}

export default SelectWithAdd;
